import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import publicroutes from './publicRoutes';
import { useEffect } from "react";
import NotFound from "../pages/NotFound/NotFound";
import dashboardRoutes from "./dashboardRoutes";
import { UserProvider } from "../contexts/UserContext";
import { CurrencyProvider } from "../contexts/CurrencyContext";

export default function AppRoutes() {
  const location: any = {};
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <Router>
      <UserProvider>
        <CurrencyProvider>
          <Routes>
            {
              dashboardRoutes.map(route =>
                <Route key={route.name} path={route.path} element={route.component} />
              )
            }
            {publicroutes.map(route =>
              <Route key={route.key} path={route.path} element={route.routeComponent} />
            )}
            <Route path='*' element={<NotFound />} />
          </Routes>
        </CurrencyProvider>
      </UserProvider>
    </Router >
  );
}
